import React from 'react';



interface CaseStudy {
  id: number;
  title: string;
  client: string;
  challenge: string;
  solution: string;
  results: string[];
  image: string;
  alt: string;
  region: string;
  timeline: string;
  category: string;
}

interface CaseStudiesProps {
  className?: string;
}

const CaseStudies = ({ className = '' }: CaseStudiesProps) => {
  const caseStudies: CaseStudy[] = [
  {
    id: 1,
    title: 'EU Market Entry for Cardiovascular Portfolio',
    client: 'Leading Indian Pharmaceutical Manufacturer',
    challenge: 'Client needed to register 12 cardiovascular products across 15 EU countries within 18 months to meet distribution agreements.',
    solution: 'Implemented centralized dossier preparation strategy with parallel country submissions, leveraging mutual recognition procedure for accelerated approvals.',
    results: [
    'All 12 products approved in 14 months',
    'Zero major deficiencies during assessment',
    '€2.3M saved through optimized submission strategy',
    'Established regulatory framework for future products'],

    image: "https://img.rocket.new/generatedImages/rocket_gen_img_15b10e24c-1764649836727.png",
    alt: 'Professional regulatory consultant reviewing pharmaceutical documentation at modern office desk with computer and medical charts',
    region: 'European Union',
    timeline: '14 months',
    category: 'Market Entry'
  },
  {
    id: 2,
    title: 'WHO-GMP Certification Achievement',
    client: 'Mid-Size Manufacturing Facility',
    challenge: 'Manufacturing facility required WHO-GMP certification to access UN procurement opportunities but had significant compliance gaps.',
    solution: 'Conducted comprehensive gap analysis, developed remediation roadmap, implemented quality systems, and provided mock audit preparation.',
    results: [
    'WHO-GMP certification achieved on first inspection',
    'Zero critical observations during audit',
    'Quality system transformation completed in 8 months',
    'Qualified for $15M UN tender opportunities'],

    image: "https://img.rocket.new/generatedImages/rocket_gen_img_156d9cc56-1765222125635.png",
    alt: 'Modern pharmaceutical manufacturing facility with stainless steel equipment and quality control systems in clean room environment',
    region: 'Global',
    timeline: '8 months',
    category: 'GMP Compliance'
  },
  {
    id: 3,
    title: 'ANVISA Registration Success',
    client: 'Specialty Pharmaceutical Company',
    challenge: 'Complex oncology product portfolio required ANVISA registration with stringent clinical data requirements and tight market entry deadlines.',
    solution: 'Prepared comprehensive technical dossiers with clinical bridging strategy, coordinated with local partners, and managed regulatory communications.',
    results: [
    '8 oncology products registered successfully',
    'Clinical bridging strategy accepted',
    'Market entry achieved 3 months ahead of schedule',
    'Established precedent for future submissions'],

    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f64b6dd5-1767434498710.png",
    alt: 'Pharmaceutical scientist in white lab coat examining medication vials in modern research laboratory with advanced equipment',
    region: 'Brazil',
    timeline: '10 months',
    category: 'Product Registration'
  }];


  return;









































































































};

export default CaseStudies;